import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  errorStatus: null,
  allTypesOfUrgency: [],
  typeOfUrgency: {},
};
const getters = {
  getApiLoad_118: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  // SET_answers(state, answers) {
  //   state.answers = answers.items;
  //   state.totalPages = answers.totalPages;
  // },
  SET_AllTypesOfUrgency(state, allTypesOfUrgency) {
    state.allTypesOfUrgency = allTypesOfUrgency;
  },
  // SET_AllActiveAnswers(state, activeAnswers) {
  //   state.allActiveAnswers = activeAnswers;
  // },
  SET_TypeOfUrgency(state, typeOfUrgency) {
    state.typeOfUrgency = typeOfUrgency;
  },
};
const actions = {
  errorTypeOfUrgency({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllTypesOfUrgencyDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/InjuryTypeDrugs/All', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllTypesOfUrgency', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTypeOfUrgency', error);
      });
  },
  getTypeOfUrgencyDispatch({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/InjuryTypeDrugs/ByIdWithDetails', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_TypeOfUrgency', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTypeOfUrgency', error);
      });
  },
  createTypeOfUrgencyDispatch({ commit, dispatch, rootState }, body) {
    return apiClient
      .post('/InjuryTypeDrugs', body, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTypeOfUrgency', error);
      });
  },

  editTypeOfUrgencyDispatch({ commit, dispatch, rootState }, body) {
    return apiClient
      .post('/InjuryTypeDrugs/Edit', body, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorTypeOfUrgency', error);
      });
  },
  // deleteAnswer({ commit, dispatch, rootState }, params) {
  //   return apiClient
  //     .post("/ChiefComplaintTriageAnswers/Remove", null, {
  //       params,
  //       headers: { "X-CSRF-Token": rootState.loginModule.csrf },
  //     })
  //     .then(() => {
  //       commit("SET_Status", true);
  //     })
  //     .catch((error) => {
  //       dispatch("errorTypeOfUrgency", error);
  //     });
  // },
  // activeAnswer({ commit, dispatch, rootState }, params) {
  //   return apiClient
  //     .post("/ChiefComplaintTriageAnswers/Activate", null, {
  //       params,
  //       headers: { "X-CSRF-Token": rootState.loginModule.csrf },
  //     })
  //     .then(() => {
  //       commit("SET_Status", true);
  //     })
  //     .catch((error) => {
  //       dispatch("errorTypeOfUrgency", error);
  //     });
  // },
  // deactivateAnswer({ commit, dispatch, rootState }, params) {
  //   return apiClient
  //     .post("/ChiefComplaintTriageAnswers/Deactivate", null, {
  //       params,
  //       headers: { "X-CSRF-Token": rootState.loginModule.csrf },
  //     })
  //     .then(() => {
  //       commit("SET_Status", true);
  //     })
  //     .catch((error) => {
  //       dispatch("errorTypeOfUrgency", error);
  //     });
  // },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
